import axiosConfig from '../axiosConfig';

export default {
	/* 
        GET         /api/v1/saved_search
    */
	index() {
		return axiosConfig.get('/saved_search');
	},

	/* 
        POST        /api/v1/saved_search
    */
	store(data) {
		return axiosConfig.post('/saved_search', data);
	},

	/* 
        PUT         /api/v1/saved_search/{id}
    */
	update(data, id) {
		return axiosConfig.put('/saved_search/' + id, data);
	},

	/* 
        DELETE     /api/v1/saved_search/{id}
    */
	destroy(id) {
		return axiosConfig.delete('/saved_search/' + id);
	},
};
